import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect } from "react";
import * as yup from "yup";

import ConditionalTooltip from "../../../ConditionalTooltip";
import * as constants from "../../../../constants";

const General = ({ user, admin, disabled, onEdit, onSubmit }) => {
  const formik = useFormik({
    initialValues: {
      displayName: user.displayName,
      role: user.role,
      officerLevel: user.officerLevel ? user.officerLevel : "NULL",
    },
    validationSchema: yup.object({
      displayName: yup.string().required("Required"),
      role: yup.string(),
      officerLevel: yup.string(),
    }),
    onSubmit: (values) => {
      onSubmit(
        {
          userId: user.userId,
          serviceProviderId: user.serviceProviderId,
          displayName: values.displayName,
          role: values.role,
          officerLevel:
            values.officerLevel === "NULL" ? null : values.officerLevel,
        },
        (user) => {
          formik.resetForm({
            values: {
              displayName: user.displayName,
              role: user.role,
              officerLevel: user.officerLevel ? user.officerLevel : "NULL",
            },
          });
        }
      );
    },
  });
  useEffect(() => {
    if (formik.dirty) {
      const resetForm = (user) => {
        formik.resetForm({
          values: {
            displayName: user.displayName,
            role: user.role,
            officerLevel: user.officerLevel ? user.officerLevel : "NULL",
          },
        });
      };
      onEdit(formik.handleSubmit, resetForm);
    }
  }, [formik.dirty]);
  useEffect(() => {
    if (!formik.dirty) {
      formik.resetForm({
        values: {
          displayName: user.displayName,
          role: user.role,
          officerLevel: user.officerLevel ? user.officerLevel : "NULL",
        },
      });
    }
  }, [user]);
  const classes = useStyles();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5">General</Typography>
        <div className={classes.separator} />
        <Divider />
      </Grid>
      <ConditionalTooltip
        title={constants.helpText.adminOnlyEdit}
        visible={!admin && !disabled}
      >
        <Grid item xs={12} sm={6}>
          <TextField
            value={formik.values.displayName}
            onChange={formik.handleChange}
            disabled={!admin || disabled}
            error={formik.errors.displayName}
            fullWidth
            helperText={formik.errors.displayName}
            label="Display Name"
            name="displayName"
            onBlur={formik.handleBlur}
            variant="filled"
          />
        </Grid>
      </ConditionalTooltip>
      <ConditionalTooltip
        title={constants.helpText.readOnly}
        visible={!disabled}
      >
        <Grid item xs={12} sm={6}>
          <TextField
            value={user.userId}
            disabled
            fullWidth
            label="Email"
            variant="filled"
          />
        </Grid>
      </ConditionalTooltip>
      <ConditionalTooltip
        title={constants.helpText.adminOnlyEdit}
        visible={!admin && !disabled}
      >
        <Grid item xs={12} sm={3}>
          <TextField
            value={formik.values.role}
            onChange={formik.handleChange}
            disabled={!admin || disabled}
            fullWidth
            label="Role"
            name="role"
            onBlur={formik.handleBlur}
            select
            SelectProps={{
              MenuProps: {
                style: styles.menus,
              },
            }}
            variant="filled"
          >
            {Object.values(constants.user.role).map((role) => (
              <MenuItem key={role.value} value={role.value}>
                {role.text}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </ConditionalTooltip>
      <ConditionalTooltip
        title={constants.helpText.adminOnlyEdit}
        visible={!admin && !disabled}
      >
        <Grid item xs={12} sm={3}>
          <TextField
            value={formik.values.officerLevel}
            onChange={formik.handleChange}
            disabled={!admin || disabled}
            fullWidth
            label="Officer Level"
            name="officerLevel"
            onBlur={formik.handleBlur}
            select
            SelectProps={{
              MenuProps: {
                style: styles.menus,
              },
            }}
            variant="filled"
          >
            {Object.values(constants.officerLevels).map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </ConditionalTooltip>
      <ConditionalTooltip
        title={constants.helpText.readOnly}
        visible={!disabled}
      >
        <Grid item xs={12} sm={3}>
          <TextField
            value={moment(user.updatedAt).format(constants.moment.format)}
            disabled
            fullWidth
            label="Last Updated"
            variant="filled"
          />
        </Grid>
      </ConditionalTooltip>
      <ConditionalTooltip
        title={constants.helpText.readOnly}
        visible={!disabled}
      >
        <Grid item xs={12} sm={3}>
          <TextField
            value={constants.user.statusText[user.status]}
            disabled
            fullWidth
            label="Status"
            variant="filled"
          />
        </Grid>
      </ConditionalTooltip>
    </Grid>
  );
};

const styles = {
  menus: {
    width: 200,
  },
};

const useStyles = makeStyles(() => ({
  verticallyCentered: {
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  separator: {
    height: 8,
  },
}));

export default General;
